import script from "./PoolTransferLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoolTransferLayout.vue?vue&type=script&setup=true&lang=ts"

import "./PoolTransferLayout.vue?vue&type=style&index=0&id=63114e3c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63114e3c"]])

export default __exports__